"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatGrupoConverter = exports.chatConverter = void 0;
exports.chatConverter = {
    toFirestore(chat) {
        return chat;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            sinLeerCliente: data.sinLeerCliente,
            sinLeerFixed: data.sinLeerFixed,
            nombreCliente: data.nombreCliente,
            nombreEmpresa: data.nombreEmpresa,
            empresaId: data.empresaId,
            clienteId: data.clienteId,
            fecha: data.fecha,
            ultimoMensaje: data.ultimoMensaje,
            vistoCliente: data.vistoCliente,
            vistoFixed: data.vistoFixed,
            urlImagenCliente: data.urlImagenCliente,
            notaPrivada: data.notaPrivada,
            notaPrivadaFija: data.notaPrivadaFija,
            escribiendoCliente: data.escribiendoCliente,
            escribiendoFixed: data.escribiendoFixed,
            pagina: data.pagina,
            resuelto: data.resuelto,
            buscableExactoPor: data.buscableExactoPor,
            dispositivo: data.dispositivo ?? "",
            navegador: data.navegador ?? "",
            grupo: data.grupo ?? "",
            // refAdjunto: data.refAdjunto,
            // urlAdjunto: data.urlAdjunto,
            // nombreAdjunto: data.nombreAdjunto,
            // tamanioAdjunto: data.tamanioAdjunto
        };
    }
};
exports.chatGrupoConverter = {
    toFirestore(chat) {
        return chat;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            nombre: data.nombre,
            agentes: data.agentes,
            chats: data.chats,
        };
    }
};
